import { GabaritoAdsQuestionElement, GabaritoAdsConfig } from './interface';
import { handleEmptyAdFallback } from './fallback';

// Função para criar fallback quando anúncio está vazio
function createRewardAdFallback(questionConfig: GabaritoAdsConfig): void {
    const interstitialId = questionConfig.emptyFallbackId as string;

    const interstitialContainer = document.createElement('div');
    interstitialContainer.id = interstitialId;
    interstitialContainer.className = 'intersticial-modal intersticial-modal--reward';

    handleEmptyAdFallback(questionConfig.emptyFallbackId as string, interstitialContainer, interstitialContainer);

    const closeButton = document.createElement('button');
    closeButton.id = 'interstitial-modal-close-button';
    closeButton.className = 'intersticial-modal__close-button';
    closeButton.innerHTML = '×';
    closeButton.setAttribute('aria-label', 'Fechar fallback reward ad');
    closeButton.setAttribute('data-track-click', 'cta-see-answer-gabarito-ad');
    interstitialContainer.appendChild(closeButton);

    const exitButton = document.createElement('button');
    exitButton.id = 'interstitial-modal-exit-button';
    exitButton.className = 'gabarito-ads__button gabarito-ads__button--enabled';
    exitButton.textContent = `Ver resposta`;
    exitButton.setAttribute('data-track-click', 'cta-see-answer-gabarito-ad');
    interstitialContainer.appendChild(exitButton);
    
    document.body.appendChild(interstitialContainer);

    console.log(`[Gabarito Reward Ads] Fallback reward ad criado document.getElementById(interstitialId)`, document.getElementById(interstitialId));
}

function showRewardAdFallback(): void {
    const modal = document.getElementById(window.sg_gabarito_ads_config.emptyFallbackId as string);
    const closeButton = document.getElementById('interstitial-modal-close-button');
    const exitButton = document.getElementById('interstitial-modal-exit-button');
    if(!modal || !closeButton || !exitButton) {
        return;
    }
    
    // Show fallback interstitial modal
    document.body.style.overflow = 'hidden';
    modal.style.display = 'flex';

    const handleClose = () => {
        modal.style.display = 'none';
        document.body.style.overflow = 'unset';
    }

    closeButton.onclick = handleClose;
    exitButton.onclick = handleClose;
}

export function cleanupRewardAdResources(): void {
    if (window.sg_gabarito_ads_config?.reloadTimeout) {
        clearTimeout(window.sg_gabarito_ads_config.reloadTimeout);
        window.sg_gabarito_ads_config.reloadTimeout = null;
        // console.log('[Gabarito Reward Ads] Timeout de reload limpo');
    }
    // console.log('[Gabarito Reward Ads] Limpeza de recursos reward concluída');
}

export function reloadGabaritoRewardAd(): void {
    console.log('[Gabarito Reward Ads] Iniciando reload do anúncio reward');
    
    if (!window.sg_gabarito_ads_config.rewardSlot) {
        console.log('[Gabarito Reward Ads] Não há slot para destruir, criando novo');
        displayGabaritoRewardAd();
        return;
    }

    window.googletag.cmd.push(() => {
        try {
            window.sg_gabarito_ads_config.rewardSlotReady = false;
            
            const currentSlot = window.sg_gabarito_ads_config.rewardSlot;
            const slotElementId = currentSlot.getSlotElementId();
            console.log('[Gabarito Reward Ads] Destruindo slot atual:', slotElementId);
            
            // O refresh não funciona no reward ads, então precisamos destruir o slot e criar um novo
            window.googletag.destroySlots([currentSlot]);
            window.sg_gabarito_ads_config.rewardSlot = null;
            
            console.log('[Gabarito Reward Ads] Slot destruído, aguardando 200ms antes de recriar');
            const reloadTimeout = setTimeout(() => {
                console.log('[Gabarito Reward Ads] Recriando slot reward após destruição');
                displayGabaritoRewardAd();
                cleanupRewardAdResources();
            }, 200);
            window.sg_gabarito_ads_config.reloadTimeout = reloadTimeout;
            
        } catch(e) {
            console.error('[Gabarito Reward Ads] Erro ao destruir slot reward:', e);
            window.sg_gabarito_ads_config.rewardSlot = null;
            const errorTimeout = setTimeout(() => {
                displayGabaritoRewardAd();
                cleanupRewardAdResources();
            }, 200);
            window.sg_gabarito_ads_config.reloadTimeout = errorTimeout;
        }
    });
}

export function displayGabaritoRewardAd(): void {
    const adPath = window.sg_gabarito_ads_config.adUnitPathMobReward;

    if (!adPath) {
        console.error('[Gabarito Reward Ads] Caminho do anúncio reward não configurado');
        return;
    }

    if (window.sg_gabarito_ads_config.rewardSlot) {
        console.log('[Gabarito Reward Ads] Slot já existe, fazendo reload');
        reloadGabaritoRewardAd();
        return;
    }

    if(window.sg_gabarito_ads_config.emptyFallbackId === undefined) {
        window.sg_gabarito_ads_config.emptyFallbackId = 'reward-interstitial-modal';
        createRewardAdFallback(window.sg_gabarito_ads_config);
    }

    window.googletag.cmd.push(() => {
        try {
            const rewardedSlotObject = window.googletag.defineOutOfPageSlot(adPath, window.googletag.enums.OutOfPageFormat.REWARDED);

            if (!rewardedSlotObject) {
                console.error('[Gabarito Reward Ads] Falha ao criar slot reward');
                return;
            }

            window.sg_gabarito_ads_config.rewardSlot = rewardedSlotObject;
            rewardedSlotObject.addService(window.googletag.pubads());
            
            // Display e refresh na primeira vez
            const actualSlotIdGPT = rewardedSlotObject.getSlotElementId();
            // console.log('[Gabarito Reward Ads] Slot ID criado:', actualSlotIdGPT);
            window.googletag.display(actualSlotIdGPT);
            window.googletag.pubads().refresh([rewardedSlotObject]);
            
            console.log('[Gabarito Reward Ads] Anúncio reward criado, display e refresh executados', rewardedSlotObject.getAdUnitPath());

        } catch(e) {
            console.error('[Gabarito Reward Ads] Erro ao criar anúncio reward:', e);
    }
    });
}

export function showGabaritoRewardAd(questionConfig: GabaritoAdsQuestionElement, slot: any): void {
    // console.log(`[Gabarito Reward Ads] Iniciando showGabaritoRewardAd para questão: ${questionConfig.id}`);

    window.sg_gabarito_ads_config.adCurrentId = questionConfig.id;
    console.log(`[Gabarito Reward Ads] Definir a questão atual: ${questionConfig.id}`);

    if (slot && window.sg_gabarito_ads_config?.rewardSlotReady) {
        // console.log('[Gabarito Reward Ads] Chamando makeRewardedVisible para exibir anúncio', slot);
        
        try {
            window.sg_gabarito_ads_config.rewardSlotEvent.makeRewardedVisible();
            console.log('[Gabarito Reward Ads] makeRewardedVisible chamado com sucesso');
        } catch(e) {
            console.log('[Gabarito Reward Ads] Erro ao chamar makeRewardedVisible:', e);
        }
    } else {
        console.log('[Gabarito Reward Ads] Slot não disponível ou não está pronto');
        showRewardAdFallback();
    }

    questionConfig.hasShown = true;

    console.log('[Gabarito Reward Ads] showGabaritoRewardAd finalizado');
}

export function setupGabaritoRewardAdsListeners(): void {
    if (!window.googletag || !window.googletag.pubads) {
        console.error('googletag ou googletag.pubads não está pronto.');
        return;
    }
    const pubads = window.googletag.pubads();

    pubads.addEventListener('slotRenderEnded', (event: any) => {
        const slot = event.slot;
        const rewardSlot = window.sg_gabarito_ads_config?.rewardSlot;

        if(slot !== rewardSlot) {
            return;
        }
        
        if(event.isEmpty) {
            window.sg_gabarito_ads_config.rewardSlotReady = false;
            window.sg_gabarito_ads_config.rewardSlotIsEmpty = true;
            console.log('[Gabarito Reward Ads] slotRenderEnded - Slot reward vazio, marcando como não pronto');
            window.sg_gabarito_ads_config.retryIsEmpty = setTimeout(() => {
                clearTimeout(window.sg_gabarito_ads_config.retryIsEmpty);
                window.sg_gabarito_ads_config.rewardSlotIsEmpty = true;
                console.log(`[Gabarito Reward Ads] retryIsEmpty - a cada ${window.sg_gabarito_ads_config.retryEmptyRewardAd === undefined ? 5000 : window.sg_gabarito_ads_config.retryEmptyRewardAd * 1000} segundos, verificando se o slot está vazio`);
                reloadGabaritoRewardAd();
            }, window.sg_gabarito_ads_config.retryEmptyRewardAd === undefined ? 5000 : window.sg_gabarito_ads_config.retryEmptyRewardAd * 1000);
            return;
        }

        window.sg_gabarito_ads_config.rewardSlotIsEmpty = false;
        clearTimeout(window.sg_gabarito_ads_config.retryIsEmpty);
        window.sg_gabarito_ads_config.rewardSlotReady = true;
        window.sg_gabarito_ads_config.rewardSlotEvent = event;
        console.log('[Gabarito Reward Ads] slotRenderEnded - Slot reward renderizado com conteúdo');
    });

    pubads.addEventListener('rewardedSlotReady', (event: any) => {
        const slot = event.slot;
        const rewardSlot = window.sg_gabarito_ads_config?.rewardSlot;

        if (slot !== rewardSlot) {
            return;
        }
        
        window.sg_gabarito_ads_config.rewardSlotReady = true;
        window.sg_gabarito_ads_config.rewardSlotEvent = event;
        console.log('[Gabarito Reward Ads] rewardedSlotReady - Slot marcado como pronto e evento armazenado');
    });

    pubads.addEventListener('rewardedSlotGranted', (event: any) => {
        const slot = event.slot;
        const rewardSlot = window.sg_gabarito_ads_config?.rewardSlot;

        if (slot !== rewardSlot) {
            return;
        }

        console.log('[Gabarito Reward Ads] rewardedSlotGranted - Recompensa concedida', event.payload);
    });

    pubads.addEventListener('rewardedSlotClosed', (event: any) => {
        const slot = event.slot;
        const rewardSlot = window.sg_gabarito_ads_config?.rewardSlot;

        if (slot !== rewardSlot) {
            return;
        }
        
        // Fazer reload do anúncio para próximo uso
        console.log('[Gabarito Reward Ads] rewardedSlotClosed - Iniciando reload do anúncio');
        reloadGabaritoRewardAd();
    });
}